import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Button, Input, Label } from "@bloom/ui";
import { useLocale } from "../locale/locale-context.tsx";
import { AuthShell } from "./login.tsx";

export function ResetPasswordPage() {
  const { t } = useLocale();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    const res = await fetch("/api/auth/reset-password", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ newPassword: password, token }),
    });
    if (!res.ok) {
      const body = (await res.json()) as { message?: string };
      setError(body.message ?? "Reset failed");
      return;
    }
    navigate("/login");
  };

  return (
    <AuthShell heading={t("auth.reset_password")}>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1">
          <Label htmlFor="password">{t("auth.password")}</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
          />
        </div>
        {error ? <p className="text-sm text-[var(--brand-rose)]">{error}</p> : null}
        <Button type="submit" className="w-full">
          {t("auth.continue")}
        </Button>
      </form>
    </AuthShell>
  );
}
